<template>
  <div class="add-data-point">

    <label class="label">Country</label>
    <span class="select">
      <select v-model="dataPoint.countryKey">
        <option disabled hidden selected="{{!dataPoint.countryKey}}">Select country</option>
        <option v-for="country in countries"
          v-bind:value="country.key"
          selected="{{dataPoint.countryKey == country.key}}">{{country.en.name}}</option>
      </select>
    </span>

    <span class="select">
      <select v-model="dataPoint.year">
        <option v-for="year in years">{{year}}</option>
      </select>
    </span>

    <span class="select">
      <select v-model="dataPoint.region">
        <option disabled hidden selected="{{!dataPoint.region}}">Select region</option>
        <option v-for="region in regions" selected="{{dataPoint.region == region}}">{{region}}</option>
      </select>
    </span>

    <label class="label">Quota advice</label>
    <input v-model="dataPoint.quotaAdvice" type="number"
      placeholder="Quota advice" class="input" number/>

    <label class="label">Quota set at</label>
    <input v-model="dataPoint.quotaSet" type="number"
      placeholder="Quota set" class="input" number/>

    <span class="select">
      <select v-model="dataPoint.peopleKeys">
        <option disabled hidden selected="{{!dataPoint.peopleKeys}}">Select people...</option>
        <option v-for="person in people"
          v-bind:value="person.key"
          selected="{{dataPoint.peopleKeys == person.key}}">
          {{person.name}}
        </option>
      </select>
    </span>

    <button v-on:click="addDataPoint" v-if="!dataPoint.key"
      class="button is-primary">Add datapoint
    </button>

    <button v-on:click="updateDataPoint(dataPoint)" v-if="dataPoint.key"
      class="button is-success">Update datapoint
    </button>
  </div>
</template>

<script>
import _ from 'underscore'
import fb from 'firebase'

export default {
  props: [
    "countries",
    "years",
    "people",
    "regions",
    "dataPoint",
  ],
  data: function() {
    return {}
  },
  ready: function() {
  },
  methods: {
    addDataPoint: function() {
      let self = this
      //console.log("Add data point: ", this.newDataPoint)
      var dataPointRef = fb.database().ref('countryDataPoints').push()
      dataPointRef.set(this.dataPoint, function(err) {
        if (err) return
        self.dataPoint.quotaOver = null
        self.dataPoint.percentOver = null
        self.dataPoint.countryKey = 0
        self.dataPoint.peopleKeys = 0
      })
    },

    deleteDataPoint: function(key) {
      fb.database().ref('countryDataPoints/' + key).set(null)
    },

    updateDataPoint: function(dataPoint) {
      let dataPointRef = fb.database().ref('countryDataPoints/' + dataPoint.key)
      dataPointRef.set(dataPoint)
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** DataPointForm.vue?7bfd10f6
 **/